import { lazy } from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import RedirectToNewNpsPage from 'modules/posts/pages/RedirectToNewNpsPage'

const RootPage = lazy(() => import('modules/posts/pages/NpsRootPage'))

const npsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.dashboard.nps.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <RedirectToNewNpsPage path={navigation.nps.fullPath()} />,
        },
      ],
    },
  ]
}

export default npsRoutes
